import {Injectable} from '@angular/core';

import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class NavParamsService {
  public state: BehaviorSubject<{ [x: string]: any }>

  constructor() {
    this.state = new BehaviorSubject<{}>({})
  }

  get(field: string) {
    return this.state.value[field];
  }

  set(setValues: { [x: string]: any }) {
    const currentState = this.state.value;
    this.state.next({...currentState, ...setValues});
  }

  remove(key: string) {
    const currentState = this.state.value;
    delete currentState[key];
    this.state.next({...currentState});
  }
}
